export default __webpack_public_path__ + "static/media/Info.f361ebd5.pdf";